import * as iconv from "iconv-lite";
import axios from "axios";
import Vue from "vue";
import { Message } from "element-ui";
import { Instance } from "@/servers/request";
import { exportTxt } from "@/servers/api.js";
import { removeTab } from "./util";

const FILE_TYPE = {
  docx: "application/msword",
  doc: "application/msword",
  bin: "application/octet-stream",
  exe: "application/octet-stream",
  so: "application/octet-stream",
  dll: "application/octet-stream",
  pdf: "application/pdf",
  ai: "application/postscript",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  dir: "application/x-director",
  js: "application/x-javascript",
  swf: "application/x-shockwave-flash",
  xhtml: "application/xhtml+xml",
  xht: "application/xhtml+xml",
  zip: "application/zip",
  mid: "audio/midi",
  midi: "audio/midi",
  mp3: "audio/mpeg",
  rm: "audio/x-pn-realaudio",
  rpm: "audio/x-pn-realaudio-plugin",
  wav: "audio/x-wav",
  bmp: "image/bmp",
  gif: "image/gif",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  png: "image/png",
  css: "text/css",
  html: "text/html",
  htm: "text/html",
  txt: "text/plain",
  xsl: "text/xml",
  xml: "text/xml",
  mpeg: "video/mpeg",
  mpg: "video/mpeg",
  avi: "video/x-msvideo",
  movie: "video/x-sgi-movie",
};

const DOWNLOAD_TIPS = {
  clipping: "正在下载剪报工具，请稍等...",
  compactDisc: "正在下载子光盘工具，请稍等...",
  exportFile: "正在导出文件，请稍等...",
};

/**
 * 下载Excel类型的文件
 * @param {String} fileName 文件名和表名
 * @param {Object} columns 表头
 * @param {Array} tableData
 */
export function downloadExcel(fileName, columns, tableData) {
  // 列名
  let columnHtml = "";
  columnHtml += '<tr style="text-align: center;">';
  for (const key in columns) {
    columnHtml +=
      '<td style="background-color:#bad5fd">' + columns[key] + "</td>";
  }
  columnHtml += "</tr>";
  // 数据
  let dataHtml = "";
  for (const data of tableData) {
    dataHtml += '<tr style="text-align: center;">';
    for (const key in columns) {
      dataHtml += "<td>" + data[key] + "</td>";
    }
    dataHtml += "</tr>";
  }
  // 完整html
  const excelHtml =
    '<html xmlns:o="urn:schemas-microsoft-com:office:office"' +
    '      xmlns:x="urn:schemas-microsoft-com:office:excel"' +
    '      xmlns="http://www.w3.org/TR/REC-html40">' +
    "<head>" +
    '   <meta http-equiv="Content-type" content="text/html;charset=utf-8"></meta>' +
    "   <!-- 加这个，其他单元格带边框 -->" +
    "   <xml>" +
    "        <x:ExcelWorkbook>" +
    "            <x:ExcelWorksheets>" +
    "                <x:ExcelWorksheet>" +
    "                    <x:Name></x:Name>" +
    "                    <x:WorksheetOptions>" +
    "                        <x:DisplayGridlines/>" +
    "                    </x:WorksheetOptions>" +
    "                </x:ExcelWorksheet>" +
    "            </x:ExcelWorksheets>" +
    "        </x:ExcelWorkbook>" +
    "   </xml>" +
    '   <style>td{font-family: "宋体";}</style>' +
    "</head>" +
    "<body>" +
    '   <table border="1">' +
    "       <thead>" +
    columnHtml +
    "       </thead>" +
    "       <tbody>" +
    dataHtml +
    "       </tbody>" +
    "   </table>" +
    "</body>" +
    "</html>";
  // 将构造好的xml内容转成文件
  downloadByBlob((fileName || "导出Excel") + ".xls", excelHtml);
}

/**
 * 通过接口下载txt文件
 * @param {string} fileName 文件名
 */
export function downloadTxt(params, fileName) {
  exportTxt(params)
    .then((res) => {
      if (!res) {
        Message.error("下载失败，请稍后再试");
        return;
      }
      // 尝试先将结果当做 JSON 解析，后端返回失败信息时直接提示
      let jsonText = "";
      if (typeof res === "string") {
        jsonText = res.trim();
      } else if (res instanceof ArrayBuffer || ArrayBuffer.isView(res)) {
        jsonText = iconv.decode(Buffer.from(res), "utf8").trim();
      }
      if (jsonText) {
        try {
          const maybeJson = JSON.parse(jsonText);
          if (maybeJson && maybeJson.success === false) {
            Message.error(maybeJson.message || "下载失败，请联系管理员");
            return;
          }
        } catch (error) {
          // 不是 json，则继续按 blob 处理
        }
      }
      const buffer = Buffer.from(res);
      if (buffer.byteLength) {
        downloadByBlob(fileName, buffer, "txt");
      } else {
        Message.error("下载失败，请稍后再试");
      }
    })
    .catch(() => {
      Message.error("下载失败，请稍后再试");
    });
}

/**
 * 通过接口下载文件
 * @param {string} url 接口地址
 * @param {string} method 请求方式post或get，默认post
 * @param {object} param 请求参数，如{ids:['1783794175847436291']}
 * @param {string} fileName 文件名称
 * @param {string} fileType 文件类型
 */
export function downByPort(data) {
  const { url, method, param, fileName, fileType } = data;
  const rootUrl = process.env.VUE_APP_API_BASE_URL;
  let baseUrl = rootUrl + url;
  axios({
    url: baseUrl,
    method: method || "post",
    data: param || {},
    responseType: "blob",
    headers: {
      "X-Access-Token": Vue.ls.get("ACCESS_TOKEN"),
      "Content-Type": "application/json; application/octet-stream",
    },
  })
    .then((res) => {
      if (res.status === 200 && res.data) {
        downloadByBlob(fileName, res.data, fileType);
      } else {
        Message.error("下载失败，请稍后重试！！！");
      }
    })
    .catch({});
}

/**
 * 通过接口下载/导出文件，提供友好提示
 * @param {string} url 接口地址
 * @param {object} param 接口参数
 * @param {string} fileType 下载文件类型
 * @param {string} fileName 文件名
 * @param {string} clue 提示标识
 * @param {string} method 请求方式
 */
export function downloadByConnector(
  url,
  param = {},
  fileType = "zip",
  fileName = "下载文件",
  clue = "exportFile",
  method = "post"
) {
  if (clue && DOWNLOAD_TIPS[clue]) {
    Message.info(DOWNLOAD_TIPS[clue]);
  }
  const isGet = (method || 'post').toLowerCase() === 'get'
  // 不要再手动拼接 VUE_APP_API_BASE_URL：Instance 已通过 baseURL 统一注入。
  // 生产环境该值为相对路径（如 '/front'），手动拼一次会让 axios 再拼一次 baseURL，
  // 结果变成 '/front/front/book/...' 而 404（开发环境是完整 http 地址，
  // axios 判定为绝对 URL 会跳过 baseURL，所以只在打包后才暴露）。
  return Instance({
    url,
    method: method ? method : 'post',
    // GET 请求参数需拼到 URL 查询串（params）；POST 才放请求体（data）
    params: isGet ? param : undefined,
    data: isGet ? undefined : param,
    responseType: "blob",
    headers: {
      "X-Access-Token": Vue.ls.get("ACCESS_TOKEN"),
      "Content-Type": "application/json; application/octet-stream",
    },
  })
    .then((res) => {
      if (res.status === 200 && res.data) {
        downloadByBlob(fileName, res.data, fileType);
        Message.success("下载成功！");
        return res;
      }
      Message.error("操作失败，请稍后重试！！！");
      return Promise.reject(new Error("DOWNLOAD_FAILED"));
    })
    .catch((error) => {
      Message.error("操作失败，请稍后重试！！！");
      return Promise.reject(error);
    });
}

/**
 * 利用Blob对象构造一个a标签的href链接，从而实现文件下载
 * @param {string} fileName 文件名
 * @param {string} source 文件资源
 * @param {string} type 下载文件类型，默认application/octet-stream(通用型)
 */
export function downloadByBlob(fileName, source, type) {
  const newFileName = removeTab(fileName) || "导出数据.txt";
  const sourceBlob = new Blob([source], {
    type: type ? FILE_TYPE[type] : "application/octet-stream",
  });
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    window.navigator.msSaveBlob(sourceBlob, newFileName);
  } else {
    const url = window.URL.createObjectURL(sourceBlob);
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", newFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  }
}

/**
 * 利用base64编码构造一个a标签的href链接，从而实现文件下载
 * @param {string} fileName 文件名
 * @param {string} source 文件资源
 */
export function downloadByBase64(fileName, source) {
  const a = document.createElement("a");
  a.href =
    "data:application/octet-stream;base64," +
    window.btoa(unescape(encodeURIComponent(source)));
  a.download = removeTab(fileName) || "导出数据.txt";
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}
